<div class="grid-section">
  <div class="toolbar">
    <dx-button
      icon="refresh"
      text="Osvježi"
      type="default"
      (onClick)="onRefreshClick()">
    </dx-button>
  </div>

  <dx-data-grid
    #produzeciGrid
    id="produzeciGrid"
    keyExpr="naziv"
    [dataSource]="gridData"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }"
    [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 50 }"
    [pager]="{
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 50, 100],
      showInfo: true
    }"
    [selection]="{ mode: 'single' }"
    [rowAlternationEnabled]="true">
    
    <dxi-column 
      dataField="naziv" 
      caption="Naziv" 
      [minWidth]="300"
      [allowFiltering]="true"
      [allowSearch]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="datum" 
      caption="Datum" 
      [width]="120"
      dataType="date"
      format="dd.MM.yyyy"
      [allowFiltering]="true"
      [sortOrder]="'desc'">
    </dxi-column>
    
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
  </dx-data-grid>
</div>

<dx-load-panel
  [position]="loadPanelPosition"
  [visible]="loading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>